import "./App.css";
import React, { Component } from "react";
import Navbar from "./components/Navbar";
import News from "./components/News";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
export default class App extends Component {
  render() {
    return (
      <Router>
        <Navbar />
        <Routes>
            <Route path="/"element={<News pageSize={6} category="general"/>}/>
            <Route path="/business"element={<News pageSize={16} category="business"/>}/>
          <Route path="/entertainment"element={<News pageSize={6} category="entertainment"/>}/>
          <Route path="/health" element={<News pageSize={6} category="health"/>}/>
          <Route path="/science"element={<News pageSize={6} category="science"/>}/>
          <Route path="/sports" element={<News pageSize={6} category="sports"/>}/>
          <Route path="/technology" element={<News pageSize={6} category="technology"/>}/>
        </Routes>
      </Router>
    );
  }
}
